import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Shown once to existing staff who joined before HIPAA acknowledgement was required.
// Saves hipaaAcknowledgedAt to Firestore and never appears again.
const HIPAAGate = () => {
  const { acknowledgeHIPAA, logout, currentUser } = useAuth();
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    if (!checked) return;
    try {
      setLoading(true);
      setError('');
      await acknowledgeHIPAA();
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#f0f4f6' }}>

      {/* Nav */}
      <nav className="flex items-center justify-between px-8 py-5"
           style={{ backgroundColor: '#1e562d' }}>
        <span className="text-white font-bold text-lg tracking-wide">
          Integrity Mental Health &amp; Coaching
        </span>
        <button
          onClick={logout}
          className="text-sm font-medium px-4 py-2 rounded-lg border border-white text-white hover:bg-white hover:text-teal-800 transition-colors"
        >
          Sign Out
        </button>
      </nav>

      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="bg-white rounded-2xl shadow-md w-full max-w-lg p-8">

          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-4"
                 style={{ backgroundColor: '#e8f0f3' }}>
              <svg className="w-7 h-7" style={{ color: '#1e562d' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold mb-2" style={{ color: '#1e562d' }}>
              Action Required
            </h1>
            <p className="text-sm text-gray-500">
              Hi {currentUser?.firstName || 'there'} — we now require all staff to acknowledge
              our HIPAA Workforce Confidentiality Agreement before accessing the portal.
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-4 mb-5 text-sm text-gray-600 leading-relaxed border border-gray-200">
            <p className="font-semibold text-gray-700 mb-2">This agreement covers:</p>
            <ul className="space-y-1 text-xs list-disc list-inside text-gray-600">
              <li>Your obligations regarding Protected Health Information (PHI)</li>
              <li>Authorized uses and minimum necessary access standards</li>
              <li>Security requirements and credential protection</li>
              <li>Mandatory breach reporting procedures</li>
              <li>Consequences of violations under HIPAA/HITECH</li>
            </ul>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 mb-5 text-xs text-amber-800 leading-relaxed">
            <strong>Important:</strong> By acknowledging below, your agreement will be recorded
            with the current date and time in the Practice's compliance records.
          </div>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="flex items-start gap-3 mb-6">
              <input
                id="hipaa"
                type="checkbox"
                checked={checked}
                onChange={e => setChecked(e.target.checked)}
                className="mt-0.5 h-4 w-4 rounded border-gray-300 cursor-pointer flex-shrink-0"
                style={{ accentColor: '#1e562d' }}
              />
              <label htmlFor="hipaa" className="text-sm text-gray-700 leading-snug cursor-pointer">
                I acknowledge that I have been trained on or will complete training on the
                Practice's HIPAA Privacy and Security policies, and I agree to comply with
                all obligations of the HIPAA Workforce Member Confidentiality & Privacy Agreement.
              </label>
            </div>

            <button
              type="submit"
              disabled={loading || !checked}
              className="w-full py-3 rounded-xl text-white font-semibold text-sm hover:opacity-90 transition-opacity disabled:opacity-50"
              style={{ backgroundColor: '#1e562d' }}
            >
              {loading ? 'Saving…' : 'I Acknowledge & Continue →'}
            </button>
          </form>

          <p className="text-xs text-gray-400 text-center mt-6 leading-relaxed">
            Your acknowledgement is required under HIPAA to access systems containing
            Protected Health Information. Contact your administrator with any questions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HIPAAGate;
